export const PAYMENT_METHOD_TYPES = {
	bankAccount: 'bank_account',
	floorPlan: 'floor_plan',
};

export const getCandidateId = (candidate) => candidate.id.toString();

export const getCandidateDisplayName = (candidate, t) => {
	if (candidate.display_name) return candidate.display_name;

	if (candidate.payment_method_type === PAYMENT_METHOD_TYPES.bankAccount && candidate.masked_last_four) {
		return t('signup:auctionAccessLookup.paymentMethodsStep.accountEnding', {
			lastFour: candidate.masked_last_four,
		});
	}

	return t(`signup:auctionAccessLookup.paymentMethodsStep.${candidate.payment_method_type}`);
};
export const isEligibleCandidate = (candidate) =>
	candidate?.eligibility_status === 'eligible' &&
	Object.values(PAYMENT_METHOD_TYPES).includes(candidate.payment_method_type);

export const getInitialPaymentMethodSelection = (paymentMethods) => {
	// selection is a local field set on sigun_up reducer to persist the selection in case that user navigates back and forth between steps 3 and 4
	const selection = paymentMethods?.selection || {};
	const buyingCandidateId = selection.buyingCandidateId || selection.buying_candidate_id || '';
	const sellingCandidateId = selection.sellingCandidateId || selection.selling_candidate_id || '';
	const selectedCandidateIds = selection.selectedCandidateIds || [buyingCandidateId, sellingCandidateId];

	return {
		buyingCandidateId: buyingCandidateId?.toString(),
		selectedCandidateIds: [...new Set(selectedCandidateIds.filter(Boolean).map(String))],
		sellingCandidateId: sellingCandidateId?.toString(),
	};
};

export const supportsPaymentMethodUse = (candidate, use) =>
	candidate.payment_method_type === PAYMENT_METHOD_TYPES.bankAccount ||
	(candidate.payment_method_type === PAYMENT_METHOD_TYPES.floorPlan && use === 'buying');
